// extracted by mini-css-extract-plugin
module.exports = {"homepage":"HomePage_homepage__17Rpb","modalBodyContainer":"HomePage_modalBodyContainer__2LsuT","modalBody":"HomePage_modalBody__n-sJi","link":"HomePage_link__2GE8B"};